const asArray = (value) => (Array.isArray(value) ? value : []);

const timestampValue = (value) => {
  const timestamp = Date.parse(value || '');
  return Number.isNaN(timestamp) ? 0 : timestamp;
};

export const getRecentActiveJDs = (jobDescriptions, limit = 5) => (
  asArray(jobDescriptions)
    .filter((jd) => String(jd?.status || '').toLowerCase() === 'active')
    .sort((left, right) => timestampValue(right?.created_at) - timestampValue(left?.created_at))
    .slice(0, limit)
);

export const countActiveCandidates = (candidates) => (
  asArray(candidates).filter(
    (candidate) => String(candidate?.status || '').toLowerCase() === 'active'
  ).length
);

export const countCallsToday = (callLogs, now = new Date()) => (
  asArray(callLogs).filter((callLog) => {
    const timestamp = callLog?.call_time || callLog?.initiated_at;
    if (!timestamp) return false;

    const callDate = new Date(timestamp);
    if (Number.isNaN(callDate.getTime())) return false;

    return callDate.getFullYear() === now.getFullYear()
      && callDate.getMonth() === now.getMonth()
      && callDate.getDate() === now.getDate();
  }).length
);
